import React, { useState } from "react";
import "./FAQ.scss";
import { Accordion, Row, Col, useAccordionButton } from "react-bootstrap";
import { SlArrowDown as Plus } from "react-icons/sl";
import GradientUnderline from "../../../Components/GradientUnderline/GradientUnderline";

const QUESTIONS = [
  {
    eventKey: 0,
    id: "q1",
    question: "How can I purchase a pass if I am not a ZiXXar member?",
    answer: (
      <>
        Only ZiXXar members can purchase passes - you can become a member by
        signing up for free here:{" "}
        <a href="https://join.zixxar.net/register" target="_blank">
          https://join.zixxar.net/register
        </a>
        .
      </>
    ),
  },
  {
    eventKey: 1,
    id: "q2",
    question: "How do I purchase a pass?",
    answer:
      "Log in to your ZiXXar account and navigate to the Shop tab, where you will see the three types of passes you can purchase: General Access NFT, VIP Access, and Premium VIP Access.",
  },
  {
    eventKey: 2,
    id: "q3",
    question: "Where can I find my pass after I purchase it?",
    answer: "You can find it in the Packages section of the Inventory tab.",
  },
  {
    eventKey: 3,
    id: "q4",
    question: "How do I claim my pass?",
    answer:
      "Go to your pass in the Packages section of the Inventory tab, press reveal and then press Claim.",
  },
  {
    eventKey: 4,
    id: "q5",
    question: "Until when can I purchase and claim my pass?",
    answer: "The deadline for both purchase and claim is the 5th of May.",
  },
];

function CustomToggle({ children, eventKey, activeId, setId, setActiveId }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActiveId(activeId === setId ? "" : setId)
  );

  return (
    <span className="custom-toggle" onClick={decoratedOnClick}>
      {children}
    </span>
  );
}

const FAQ = () => {
  const [activeId, setActiveId] = useState("q1");

  return (
    <div id="event-faq" className="section-margins">
      <div className="large-container d-flex align-items-start justify-content-start flex-column gap-5">
        <div className="d-flex align-items-start justify-content-start flex-column gap-2 w-100">
          <h2 className="font-pnb font-size-64">FAQ.</h2>
          <GradientUnderline />
          <span className="font-size-18 font-pnr color-light-grey">
            Our comprehensive FAQ section is here to help
          </span>
        </div>

        <Accordion className="dark-grey-color w-100" defaultActiveKey="0">
          <Row xs={1} sm={1} md={1} lg={1} xl={2}>
            <Col>
              {QUESTIONS.slice(0, QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? "active-item" : ""}`}
                  >
                    <Accordion.Header className=" white-color font-pnsb mb-10px ">
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className="white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between ">
                          {el.question}
                          <div>
                            <Plus className="button-transition" />
                          </div>
                        </div>{" "}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <p className="large-container font-pnr font-size-18 line-height-18  white-color">
                        {el.answer}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Col>
            <Col>
              {QUESTIONS.slice(QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? "active-item" : ""}`}
                  >
                    <Accordion.Header className=" white-color font-pnsb mb-10px ">
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className="white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between ">
                          {el.question}
                          <div>
                            <Plus className="button-transition" />
                          </div>
                        </div>{" "}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <p className="large-container font-pnr font-size-18 line-height-18  white-color">
                        {el.answer}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Col>
          </Row>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
